import * as Yup from "yup";

export default Yup.object().shape({
    isActive: Yup.bool(),
    ssn: Yup.string(),
    hourlyRate: Yup.number(),
    role: Yup.string(),
});